module.exports = __webpack_public_path__ + "img/2ef6832.jpg";